import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { computed, defineComponent, onMounted, ref } from 'vue';
import dayjs from 'dayjs';
import { useEmptyStringFormat } from '@/hooks/fn';
import useTotalData from './hooks/useTotalData';
import useSparePartsTrend from './hooks/useSparePartsTrend';
import { BarEchartMul } from '@/components/page-echarts';
import { useRouter } from 'vue-router';
import localCache from '@/utils/localCache';
export default defineComponent({
  name: 'PurchaseSpareParts',
  components: {
    BarEchartMul: BarEchartMul
  },
  setup: function setup() {
    var switchClick = function switchClick() {
      window.location.href = "/table/buySpare.html?factoryId=".concat(localCache.getItem('factoryId'));
    };
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var _dateRef$value;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              if (val === 4) {
                params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
              } else {
                params.value.date = dayjs().format('YYYY/MM/DD');
              }
              getTotalDataAsync();
              getSparePartsAsync();
              getSparePartsYearAsync();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var confrimDate = function confrimDate(val) {
      params.value.date = val;
      getTotalDataAsync();
      getSparePartsAsync();
      getSparePartsYearAsync();
    };
    var params = ref({
      type: 0,
      date: dayjs().format('YYYY/MM/DD')
    });
    var title = computed(function () {
      var text = '';
      if (params.value.type === 0) {
        text = '各日采购对比';
      } else if (params.value.type === 1) {
        text = '各周采购对比';
      } else if (params.value.type === 2) {
        text = '各月采购对比';
      } else if (params.value.type === 3) {
        text = '各年采购对比';
      } else if (params.value.type === 4) {
        text = '自定义时间范围采购对比';
      }
      return text;
    });
    var _useTotalData = useTotalData(params),
      _useTotalData2 = _slicedToArray(_useTotalData, 3),
      totalData = _useTotalData2[0],
      summaryData = _useTotalData2[1],
      getTotalDataAsync = _useTotalData2[2];
    var _useSparePartsTrend = useSparePartsTrend(params),
      _useSparePartsTrend2 = _slicedToArray(_useSparePartsTrend, 4),
      trendData = _useSparePartsTrend2[0],
      trendData1 = _useSparePartsTrend2[1],
      getSparePartsAsync = _useSparePartsTrend2[2],
      getSparePartsYearAsync = _useSparePartsTrend2[3];
    onMounted(function () {
      console.log(totalData, 'totalData');
      getTotalDataAsync();
      getSparePartsAsync();
      getSparePartsYearAsync();
    });
    var emptyStringFormat = useEmptyStringFormat();
    var purchaseDataTrend = computed(function () {
      var lineData1 = trendData.value.map(function (item) {
        return item.singular;
      });
      var lineData2 = trendData.value.map(function (item) {
        return item.tot_money;
      });
      var xLabels = trendData.value.map(function (item) {
        return item.time;
      });
      var legendData = ['单数', '金额'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F'],
        grid: {
          left: 50,
          top: 60,
          bottom: 30,
          right: 20
        },
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params) {
          var res = "\n              <div >\n                <div class=\"flex align-center\">\n                  <span class=\"ml-2\">".concat(params[0].axisValue, "</span>\n\n                </div>\n              ");
          params.forEach(function (item) {
            res += "\n                <div >\n                  ".concat(item.marker, "\n                  <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                  <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '金额' ? '万' : '', "</span>\n                </div>\n              ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var purchaseDataTrend1 = computed(function () {
      var lineData1 = trendData1.value.map(function (item) {
        return item.singular;
      });
      var lineData2 = trendData1.value.map(function (item) {
        return item.tot_money;
      });
      var xLabels = trendData1.value.map(function (item) {
        return item.time;
      });
      var legendData = ['单数', '金额'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F'],
        grid: {
          left: 50,
          top: 60,
          bottom: 30,
          right: 20
        },
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params) {
          var res = "\n              <div >\n                <div class=\"flex align-center\">\n                  <span class=\"ml-2\">".concat(params[0].axisValue, "</span>\n\n                </div>\n              ");
          params.forEach(function (item) {
            res += "\n                <div >\n                  ".concat(item.marker, "\n                  <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                  <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '金额' ? '万' : '', "</span>\n                </div>\n              ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var router = useRouter();
    var toDetail = function toDetail() {
      router.push({
        name: 'SpartPartsDetail',
        params: {
          type: params.value.type //日期类型 日周月年自定义
        }
      });
    };
    return {
      switchClick: switchClick,
      emptyStringFormat: emptyStringFormat,
      summaryData: summaryData,
      purchaseDataTrend: purchaseDataTrend,
      purchaseDataTrend1: purchaseDataTrend1,
      confrimDate: confrimDate,
      confirmType: confirmType,
      title: title,
      params: params,
      dateRef: dateRef,
      toDetail: toDetail
    };
  }
});